import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">

          <div className="newsletter-content">
            <div className='newsletter-content-main'>
              <div className="newsletter-text">
                <h2>Stay Updated</h2>
                <p>Subscribe to our newsletter and get the latest job openings delivered to your inbox</p>
              </div>
              <form className="newsletter-form">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="newsletter-input"
                />
                <button
                  type="submit"
                  className="newsletter-btn"
                >
                  Subscribe
                </button>
              </form>
            </div>

            <div className='footer_link_main'>
              <div className="footer-section">
                <h4>Quick Links</h4>
                <ul className="footer-links">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4>For Job Seekers</h4>
                <ul className="footer-links">
                  <li><Link to="/register">Create Account</Link></li>
                  <li><Link to="/login">Sign In</Link></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4>For Employers</h4>
                <ul className="footer-links">
                  <li><Link to="/register">Post a Job</Link></li>
                  <li><Link to="/login">Employer Login</Link></li>
                </ul>
              </div>

            </div>
          </div>

          <div className="footer-content-2">
            <div className="footer-section" style={{ marginBottom: '25px' }}>
              <Link to="/">
                <img src="/images/logo-footer.png" alt="HiringOpen" className="logo-footer" />
              </Link>
              <p>Your trusted job portal for finding the perfect career opportunity.
                Explore exciting job openings, connect with top companies, and find
                opportunities that match your skills, experience, and career goals.</p>
            </div>

            <div className="footer-section">
              <h4>Follow Us</h4>
              <div className="social-links-horizontal">
                <a href="https://www.facebook.com/HiringOpenInc/" target="_blank" rel="noopener noreferrer" className="social-link facebook" title="Follow us on Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                {/* <a href="https://www.twitter.com/HiringOpenInc" target="_blank" rel="noopener noreferrer" className="social-link twitter" title="Follow us on Twitter">
                <i className="fab fa-twitter"></i>
              </a> */}
                <a href="https://www.linkedin.com/company/hiringopen/" target="_blank" rel="noopener noreferrer" className="social-link linkedin" title="Follow us on LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                {/* <a href="https://www.instagram.com/hiringopen" target="_blank" rel="noopener noreferrer" className="social-link instagram" title="Follow us on Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.youtube.com/@HiringOpen" target="_blank" rel="noopener noreferrer" className="social-link youtube" title="Subscribe on YouTube">
                <i className="fab fa-youtube"></i>
              </a> */}
              </div>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} HiringOpen. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
